import React from 'react';
import { buildMonthCells, isDayCellClickable } from './monthGridUtils';

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const MonthGrid = ({ year, month, days, onSelectDay }) => {
  const cells = buildMonthCells(year, month);

  return (
    <div className="cal-grid" role="grid" aria-label="Batch schedule calendar">
      {WEEKDAYS.map((w) => (
        <div key={w} className="cal-weekday" role="columnheader">{w}</div>
      ))}
      {cells.map((cell, i) => {
        if (!cell.date) return <div key={`b${i}`} className="cal-cell cal-cell-empty" />;
        const items = days[cell.date] || [];
        const dayNum = Number(cell.date.slice(8, 10));
        return (
          <button
            key={cell.date}
            type="button"
            className="cal-cell"
            /* An empty day must open too — the drawer's Add-session panel is
               the only way to author a class, and a day with no class yet is
               exactly the day an admin wants to schedule one on. */
            onClick={() => isDayCellClickable(cell) && onSelectDay(cell.date)}
            aria-label={`${cell.date}, ${items.length} schedule(s)`}
          >
            <span className="cal-daynum">{dayNum}</span>
            <span className="cal-chips">
              {items.map((it) => {
                const flagged = it.flags && it.flags.length > 0;
                const key = it.groupKey || it.id;
                const chapterName = it.chapter ? it.chapter.name : null;
                const topicName = it.chapter && it.chapter.topic ? it.chapter.topic.name : null;
                const tooltip = [
                  it.subject || 'Class',
                  chapterName,
                  topicName,
                  it.mode,
                  it.section ? `Sec ${it.section}` : null,
                  it.time,
                ].filter(Boolean).join(' · ');

                return (
                  <span
                    key={key}
                    className={`cal-chip${flagged ? ' cal-chip-flagged' : ' cal-chip-ok'}`}
                    title={tooltip}
                  >
                    <span className="cal-chip-top">
                      <i className={`bi ${flagged ? 'bi-exclamation-triangle-fill' : 'bi-check-circle-fill'}`} />
                      <span className="cal-chip-label">{it.subject || it.mode || 'Class'}</span>
                      {it.mode && (
                        <span className={`cal-chip-mode cal-chip-mode-${it.mode.toLowerCase().replace(/\s+/g, '-')}`}>
                          {it.mode}
                        </span>
                      )}
                    </span>
                    {/* The chapter is read back from the session's contents, so a
                        class whose content is not linked yet has none to show. */}
                    {(chapterName || it.section) && (
                      <span className="cal-chip-sub">
                        {chapterName && <span className="cal-chip-chapter">{chapterName}</span>}
                        {it.section && <span className="cal-chip-section">Sec {it.section}</span>}
                      </span>
                    )}
                  </span>
                );
              })}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default MonthGrid;
